import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

interface OrderTablesTitleStyles {
    wrapper?: InjectableCss;
    titleText?: InjectableCss;
}

interface Props {
    text: string;
}

const styles: OrderTablesTitleStyles = {
    wrapper: {
        css: css`
            margin-bottom: 30px;
            margin-top: 30px;
            border-bottom: 1px solid #ddd;
            display: flex;
            justify-content: flex-start;
        `,
    },
    titleText: {
        css: css`
            font-family: myriad-pro, sans-serif;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.33;
            letter-spacing: normal;
            color: #e82011;
            background-color: transparent;
            border: 0;
            position: relative;
            padding: 10px 0;
            text-align: center;
            min-width: 100px;

            &::after {
                content: "";
                position: absolute;
                background-color: #e82011;
                top: 95%;
                width: 100%;
                height: 5px;
                left: 0;
            }
        `,
    },
};

const OrderTablesTitle = ({ text }: Props) => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography as="h2" {...styles.titleText} id="orderAck">
                {text}
            </Typography>
        </StyledWrapper>
    );
};

export default OrderTablesTitle;
